import { Injectable } from '@angular/core';
import { ContentObject } from '../app.models';
import { AppService } from '../app.service';
import { ApplicationInsightsService } from '../application-insights.service';

@Injectable({
  providedIn: 'root',
})
export class IntroductionService {
  constructor(
    private appService: AppService,
    private applicationInsightsService: ApplicationInsightsService,
  ) {
    if (!this.appService.introText) {
      this.appService.getIntroContent();
    }
  }

  contentObject: ContentObject[] = this.appService.introText;

  getContent(name: string): string {
    try {
      var result = this.contentObject.find((obj) => {
        return obj.key.toLowerCase() === name.toLowerCase();
      });

      return result.value;
    } catch (exception) {
      this.applicationInsightsService.logException(exception);
      return '';
    }
  }
}
